// ===== Global Protection Script =====
(() => {
    if (window.appConfig?.env === 'local') {
        return;
    }

    // --- Disable right-click globally ---
    document.addEventListener('contextmenu', (e) => {
        e.preventDefault();
    });

    // --- Disable keyboard shortcuts for DevTools / View Source / Save Page ---
    document.addEventListener('keydown', (e) => {
        const key = (e.key || '').toLowerCase();
        const meta = e.ctrlKey || e.metaKey;

        // allow typing/copying inside form fields
        const isTyping = ['input','textarea','select'].includes(e.target.tagName.toLowerCase()) || e.target.isContentEditable;
        if (isTyping) return;

        // block common debug/view/save shortcuts
        if (
            e.key === 'F12' ||
            (meta && e.shiftKey && ['i','j','c'].includes(key)) || // DevTools panes
            (meta && ['u','s','p'].includes(key))                  // view source / save / print
        ) {
            e.preventDefault();
            e.stopPropagation();
        }
    }, true);
})();

// ===== Run DevTools detection ONLY on supported browsers =====
// (function () {
//     // --- helpers: detect engines & platforms safely ---
//     const ua = navigator.userAgent || '';
//     const uaData = navigator.userAgentData;

//     const isMobile = () => /Mobile|Android|iPhone|iPad|iPod/i.test(ua);
//     // includes desktop Safari & iOS WebKit
//     const isSafariFamily = () => /Safari/i.test(ua) && !/Chrome|Chromium|Edg|OPR|Brave/i.test(ua);

//     const isChromiumDesktop = () => {
//         if (uaData && Array.isArray(uaData.brands)) {
//             const brands = uaData.brands.map(b => (b.brand || '').toLowerCase());
//             const chromiumish = brands.some(b => b.includes('chromium') || b.includes('google chrome'));
//             return chromiumish && !isMobile();
//         }
//         // fallback UA regex
//         return /Chrome|Chromium|Edg|OPR|Brave/i.test(ua) && !isMobile();
//     };

//     const isFirefoxDesktop = () => /Firefox/i.test(ua) && !isMobile();

//     const supportsDevtoolsDetection = () =>
//         (isChromiumDesktop() || isFirefoxDesktop()) && !isSafariFamily();

//         if (!supportsDevtoolsDetection()) return; // Skip unreliable engines (Safari/iOS/Android/WebViews)

//         // --- robust-ish DevTools detection for Chromium/Firefox desktop ---
//         // Combines outer/inner diffs & a resize hook to reduce false positives.
//         const THRESHOLD = 160; // safe for docked/undocked panels on Chromium/Firefox
//         let open = false;

//         const detect = () => {
//             const wDiff = Math.abs((window.outerWidth || 0) - (window.innerWidth || 0));
//             const hDiff = Math.abs((window.outerHeight || 0) - (window.innerHeight || 0));
//             const availDiff = Math.abs((screen.availHeight || 0) - (window.innerHeight || 0));

//             // if any dimension suggests a devtools pane
//             const likely = (wDiff > THRESHOLD) || (hDiff > THRESHOLD) || (availDiff > THRESHOLD);
//             if (likely && !open) {
//                 open = true;
//                 // Your response when DevTools is detected:
//                   document.body.innerHTML = "<h2 style='text-align:center;margin-top:20vh;font-family:sans-serif;'>⚠️ Developer tools are disabled on this site.</h2>";
//             }
//         };

//         // poll + react to resize (opening devtools triggers resize)
//         const interval = setInterval(detect, 1200);
//         window.addEventListener('resize', detect, { passive: true });

//         // optional: stop polling after first trigger or after some time
//         setTimeout(() => { if (!open) clearInterval(interval); }, 30000); // stop after 30s if nothing detected
// })();
